// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"

Rails.start()
Turbolinks.start()
ActiveStorage.start()




// Theme
import '../theme/theme'

// Commom JS files
// import '../common_js_files/address_valid'
import '../common_js_files/alertflash'
import '../common_js_files/delete_address_popup'
import '../common_js_files/copy_button'
import '../common_js_files/show_notification'
import '../common_js_files/wordpress_installer'



window.infoModal = function(message, okCallback) {
  $('#infoModalTitle').html(message);
  $('#infoModal').modal('show');
  $('#btnok').html("Close");
  $('#btnok').off('click');
  $('#btnok').click(function() {
  $('#info_modal_alert_title h3').html("Alert");

    if(okCallback)
      okCallback();
  $('#infoModal').modal('hide');
  });
}




